var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.responsive
    ? _c(
        "div",
        [
          _vm.BOARDS.length
            ? _vm._l(_vm.BOARDS, function (ref) {
                var name = ref.name
                var owner = ref.owner
                var ownerDetails = ref.ownerDetails
                var isDefault = ref.default
                var id = ref.id
                var number = ref.numberOfClients
                return _c(
                  "a",
                  {
                    key: id,
                    staticClass:
                      "dropdown-item board-link text-truncate pl-4 mb-1 p-2 clickable",
                    on: {
                      click: function ($event) {
                        return _vm.transferProfile(id, $event)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "bold" }, [
                      _vm._v("\n        " + _vm._s(name) + "\n        "),
                      isDefault && owner
                        ? _c("span", [
                            _vm._v(
                              "\n          (" +
                                _vm._s(_vm.$t("global.words.default")) +
                                ")\n        "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("boards.messages.boardOwner")) +
                          ": " +
                          _vm._s(ownerDetails.givenName) +
                          "\n        " +
                          _vm._s(ownerDetails.familyName) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.numberOfClients(number)) +
                          "\n      "
                      ),
                    ]),
                  ]
                )
              })
            : _c("div", [
                _c(
                  "p",
                  {
                    staticClass:
                      "text-center m-0 px-3 py-3 font-sm text-regular-gray",
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$t("boards.messages.noBoardSharedWithClientOwner")
                        ) +
                        "\n    "
                    ),
                  ]
                ),
              ]),
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "dropdown-item clickable wide px-4" },
        [
          !_vm.client.clientProfiles.length
            ? _c(
                "button",
                {
                  staticClass: "btn btn-white",
                  on: {
                    click: function ($event) {
                      return _vm.transferProfile(_vm.BOARDS[0].id, $event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("application.listing.addToBoard")) +
                      "\n  "
                  ),
                ]
              )
            : _c(
                "router-link",
                {
                  staticClass:
                    "btn clickable btn-white action-button btn-sm bold",
                  attrs: {
                    role: "button",
                    to: _vm.getProfileLink(
                      _vm.client.clientProfiles[0].id,
                      _vm.client.clientProfiles[0].boardId
                    ),
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("application.listing.viewOnBoard")) +
                      "\n  "
                  ),
                ]
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }